module.exports = __webpack_public_path__ + "media/images/product_owners/sml_aerial_networks_90-2f6925fdc12e859b5ad387d1695742cb.png";